module.exports = __webpack_public_path__ + "static/media/bg24.f6315921.jpg";